// ##############################
// // // App styles
// #############################

import {
  drawerWidth,
  drawerMiniWidth,
  transition,
  containerFluid
} from "./material-dashboard-pro-react.jsx"

const appStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    minHeight: "100vh",
    "&:after": {
      display: "table",
      clear: "both",
      content: '" "'
    },
    backgroundColor: "#f7f7f7"
  },
  mainPanel: {
    minHeight: "100vh",
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    position: "relative",
    float: "right",
    ...transition,
    width: "100%",
    overflowScrolling: "touch"
  },
  content: {
    marginTop: "0px",
    padding: "0px 0px",
    minHeight: "100vh"
  },
  container: {
    ...containerFluid,
    paddingRight: "0px",
    paddingLeft: "0px",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column"
  },
  map: {
    marginTop: "70px"
  },
  mainPanelSidebarMini: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerMiniWidth}px)`
    }
  },
  mainPanelWithPerfectScrollbar: {
    overflow: "hidden !important"
  }
})

export default appStyle
